var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "ReleaseJY",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.TakeContainerJY"),
        "close-on-click-modal": false,
        width: "500px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.dialogClose
      }
    },
    [
      _c("div", { staticStyle: { display: "flex", "margin-top": "20px" } }, [
        _c("span", { staticStyle: { margin: "5px" } }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.TakeContRemarks")))
        ]),
        _c(
          "div",
          { staticStyle: { width: "70%", "margin-left": "10px" } },
          [
            _c("el-input", {
              attrs: { type: "textarea", rows: 5, no: "remark" },
              model: {
                value: _vm.remark,
                callback: function($$v) {
                  _vm.remark = $$v
                },
                expression: "remark"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.jyTakeContainer()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c("el-button", { on: { click: _vm.dialogClose } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }